export const AccountActionText = {
  upgradeText: "Are you sure you want to change your plan?",
  downgradeText: "Are you sure you want to downgrade your plan?",
  skipText: "Are you sure you want to skip your next billing cycle?",
  unskipText: "Are you sure you want to remove the pending skip on your plan?",
  reactivateText: "Are you sure you want to reactivate your plan?",
  cancelText: "Are you sure you want to cancel your plan?",
  uncancelText: "Are you sure you want to remove the pending cancel on your plan?",
  cancelNextProductText: "Are you sure you want to cancel your plan change?",
};

export const AccountActionAdminText = {
  upgradeText: "Are you sure you want to upgrade user's plan?",
  skipText: "Are you sure you want to skip user's next billing cycle?",
  unskipText: "Are you sure you want to remove the pending skip on user's plan?",
  reactivateText: "Are you sure you want to reactivate user's plan?",
  cancelText: "Are you sure you want to cancel user's plan?",
  uncancelText: "Are you sure you want to remove the pending cancel on user's plan?",
};
